import { $ } from "../utils/dom";
import { NOT_FIRST_VISIT_KEY } from "./../constants/not-first-visit-key";
import { Modal } from "./modal";

import * as store from "store";

export class Help {
  private static singleton: Help;
  private modal: Modal;
  private $el: HTMLButtonElement;

  private constructor() {
    this.modal = Modal.instance;
    this.$el = $("#js__help") as HTMLButtonElement;
  }

  public init() {
    this.$el.addEventListener("click", this.handleClick.bind(this));
    window.addEventListener("load", this.showHelpOnInit.bind(this));
  }

  private showHelpOnInit() {
    const isNotFirstVisit = store.get(NOT_FIRST_VISIT_KEY);
    if (isNotFirstVisit) {
      return;
    }
    this.modal.show("help", isNotFirstVisit).then(dontShow => {
      if (dontShow) {
        store.set(NOT_FIRST_VISIT_KEY, true);
      }
    });
  }

  private handleClick() {
    this.modal.show("help", false);
  }

  /**
   * Creates an unique instance of AppComponent
   *
   * @readonly
   * @static
   * @type {AppComponent}
   * @memberof AppComponent
   */
  public static get instance(): Help {
    if (!Help.singleton) {
      Help.singleton = new Help();
    }
    return Help.singleton;
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/components/help.ts